import Vue from 'vue'

import {
  Aside,
  Autocomplete,
  Badge,
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  Container,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Header,
  Image,
  Input,
  InputNumber,
  Loading,
  Main,
  Menu,
  MenuItem,
  MenuItemGroup,
  Message,
  Option,
  OptionGroup,
  Pagination,
  Popover,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Submenu,
  Switch,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  TimeSelect,
  Upload,
  Tooltip,
  Progress,
  Alert,
  Steps,
  Step,
  Collapse,
  CollapseItem,
} from 'element-ui'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

Vue.use(Header)
Vue.use(Button)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Input)
Vue.use(Form)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(FormItem)
Vue.use(InputNumber)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Upload)
Vue.use(Autocomplete)
Vue.use(Popover)
Vue.use(Image)
Vue.use(OptionGroup)
Vue.use(Cascader)
Vue.use(Row)
Vue.use(Col)
Vue.use(Badge)
Vue.use(Tag)
Vue.use(TimeSelect)
Vue.use(Tooltip)
Vue.use(Progress)
Vue.use(Alert)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Collapse)
Vue.use(CollapseItem)

Vue.use(Loading)
Vue.component(CollapseTransition.name, CollapseTransition)

Vue.prototype.$message = Message
window.message = Message
